import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const ReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StarsContainer = styled.ul`
  padding: 0;
  display: flex;
  color: ${({ iconColor }: { iconColor?: string }) =>
    iconColor ? iconColor : fromTheme('color_star_ratings')};
  font-size: 1rem;

  svg path {
    fill: currentColor !important;
  }
`;

export const StarContainer = styled.li`
  list-style: none;
  margin-right: 2px;
`;

export const DateContainer = styled.span`
  color: ${fromTheme('color_text_secondary')};
`;

export const BodyContainer = styled.p`
  && {
    margin: ${fromTheme('spacing_medium')} 0 ${fromTheme('spacing_large')} 0;
  }
  color: ${fromTheme('color_text')};
  line-height: 1.64;
`;

export const NoRating = styled.span`
  color: ${fromTheme('color_text_secondary')};
  font-size: ${fromTheme('font_size')};
`;
